import request from '@/utils/request';

// 供应商_退货地址
export const getProviderReturnLogistics = (data: any): any =>
  request({
    url: '/provider/returnAddress/returnAddressList',
    data: data
  })

// 供应商_退货地址创建
export const createProviderReturnLogistics = (data: any): any =>
  request({
    url: '/provider/returnAddress/returnAddressSave',
    data: data
  })

// 供应商_退货地址详情
export const getProviderReturnLogisticsDetail = (data: any): any =>
  request({
    url: '/provider/return/logistics/info',
    data: data
  })

// 供应商_设置退货地址
export const setProviderReturnLogistics = (data: any): any =>
  request({
    url: '/provider/return/logistics/set',
    data: data
  })

// 供应商_删除退货地址
export const delProviderReturnLogistics = (data: any): any =>
  request({
    url: '/provider/returnAddress/returnAddressDelete',
    data: data
  })

// 物流公司
export const getExpressList = (data: any): any =>
  request({
    url: '/api/express/list',
    data: data
  })


// 物流模板操作
export const doLogisticsTpl = (data: any): any =>
  request({
    url: '/provider/freightTemplate/freightTemplateDelete',
    data
  })

// 物流模板列表
export const logisticsTplList = (data: any): any =>
  request({
    url: '/logistics/tpl/list',
    data
  })
// 物流模板详情
export const freightTemplateInfo = (data: any): any =>
  request({
    url: '/provider/freightTemplate/freightTemplateInfo',
    data
  })
// 物流模板列表
export const freightTemplateSave = (data: any): any =>
  request({
    url: '/provider/freightTemplate/providerFreightTemplateSave',
    data
  })

// 供应商模板列表
export const providerLogisticsTplList = (data: any): any =>
  request({
    url: '/provider/freightTemplate/Providerlist',
    data
  })

// 物流单导入/导出
export const logisticsExcel = (data: any): any =>
  request({
    url: '/logistics/excel',
    data
  })

// 物流单导入发货单
export const sellOrderDetailImport = (data: any): any =>
  request({
    url: '/provider/order/sellOrderDetailImport',
    data
  })

// 获取物流单地址
export const getLogisticsExcelUrl = (data: any): any =>
  request({
    url: '/logistics/url',
    data
  })

// 订单发货
export const transportOrder = (data: any) : any =>
  request({
    url: '/provider/order/send',
    data
  })
// 订单修改物流
export const expressedit = (data: any) : any =>
  request({
    url: '/provider/order/express/edit',
    data
  })

// 销售订单（供货商订单）-发货通知状态更新
export const orderchangeMiniProgramAppSMSShipNoticeState = (data: any) : any =>
request({
  url: '/provider/order/changeMiniProgramAppSMSShipNoticeState',
  data
})



// 获取物流结算模板
export const freightSettlementTemplatefreightSettlementTemplateList = (data: any) : any =>
request({
  url: '/provider/freightSettlementTemplate/freightSettlementTemplateList',
  data
})
// 删除物流结算模板
export const freightSettlementTemplatefreightSettlementTemplateDelete = (data: any) : any =>
request({
  url: '/provider/freightSettlementTemplate/freightSettlementTemplateDelete',
  data
})
// 获取物流结算模板详情
export const freightSettlementTemplatefreightSettlementTemplateInfo = (data: any) : any =>
request({
  url: '/provider/freightSettlementTemplate/freightSettlementTemplateInfo',
  data
})
// 物流结算模板保存
export const freightSettlementTemplatefreightSettlementTemplateSave = (data: any) : any =>
request({
  url: '/provider/freightSettlementTemplate/freightSettlementTemplateSave',
  data
})
// 物流结算模板修改记录
export const freightSettlementTemplatefreightSettlementTemplateRecord = (data: any) : any =>
request({
  url: '/provider/freightSettlementTemplate/freightSettlementTemplateRecord',
  data
})

